// extracted by mini-css-extract-plugin
export default {"textInput":"textInput__jxWrT","label":"label__Op5eT","scoreButton":"scoreButton__SM1OR","move_next_to":"move_next_to__cLz77"};